import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum RoundingPrecisionId {
  HUNDREDTH = 'hundredth',
  TENTH = 'tenth',
  UNIT = 'unit',
}

export class RoundingPrecision extends Codebook<RoundingPrecisionId> {
  private constructor(
    public readonly id: RoundingPrecisionId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly HUNDREDTH = new RoundingPrecision(RoundingPrecisionId.HUNDREDTH, () =>
    $t('Hundredths'),
  )

  static readonly TENTH = new RoundingPrecision(RoundingPrecisionId.TENTH, () => $t('Tenths'))

  static readonly UNIT = new RoundingPrecision(RoundingPrecisionId.UNIT, () => $t('Units'))
}
